module.exports = __webpack_public_path__ + "static/media/credits-sm.103e010c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/credits-sm.jpg
// module id = 154
// module chunks = 11